export const SEARCH_REQUEST = 'search/REQUEST';
export const SEARCH_RECEIVED = 'search/RECEIVED';
export const SEARCH_UPDATE_QUERY = 'search/SEARCH_UPDATE_QUERY';
export const SEARCH_UPDATE_FILTER = 'search/UPDATE_FILTER';
export const SEARCH_RESET_FILTER = 'search/RESET_FILTER';
export const SEARCH_RESET_SEARCH = 'search/SEARCH_RESET_SEARCH';
